/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommonAllEnumeratorsResultSingleResult } from '../models/CommonAllEnumeratorsResultSingleResult';
import type { GastroCartValidateResult } from '../models/GastroCartValidateResult';
import type { MenuResultCollectionResult } from '../models/MenuResultCollectionResult';
import type { OfferMealTypeResultCollectionResult } from '../models/OfferMealTypeResultCollectionResult';
import type { OfferResultCollectionResult } from '../models/OfferResultCollectionResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaGastroService {
    /**
     * @returns void
     * @throws ApiError
     */
    public static getApiVGsoaGastroIsAlive({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/gastro/isAlive',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * Returns validated cart
     * @returns GastroCartValidateResult Validated card
     * @throws ApiError
     */
    public static cartValidate({
        frontendId,
        localityId,
        requestBody,
        apiVersion = 1,
        productTypeId,
    }: {
        /**
         * Frontend identifier
         */
        frontendId: number,
        /**
         * Globus hypermarket number in format XXXX.
         */
        localityId: number,
        requestBody: Array<number>,
        apiVersion?: number,
        /**
         * Product type ID, if omitted, parameter is set to 1
         */
        productTypeId?: number,
    }): CancelablePromise<GastroCartValidateResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/gastro/cart/validate',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'frontendId': frontendId,
                'localityId': localityId,
                'productTypeId': productTypeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns the valid offers of meals for a frontend.
     * @returns OfferResultCollectionResult Offers were successfully found.
     * @throws ApiError
     */
    public static getMealOffers({
        frontendId,
        localityId,
        apiVersion = 1,
        productTypeId,
    }: {
        /**
         * Frontend identifier
         */
        frontendId: number,
        /**
         * Globus hypermarket number in format XXXX.
         */
        localityId: number,
        apiVersion?: number,
        /**
         * Product type ID, if omitted, parameter is set to 1
         */
        productTypeId?: number,
    }): CancelablePromise<OfferResultCollectionResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/gastro/offers/all',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'frontendId': frontendId,
                'localityId': localityId,
                'productTypeId': productTypeId,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns the valid offers of meals for a frontend.
     * @returns OfferMealTypeResultCollectionResult Offers were successfully found.
     * @throws ApiError
     */
    public static getMealOffersMealType({
        frontendId,
        localityId,
        limit,
        offset,
        apiVersion = 1,
        productTypeId,
        tags,
        onlyOrderableNow = false,
        onlyOrderableToday = true,
        offerIds,
    }: {
        /**
         * Frontend identifier
         */
        frontendId: number,
        /**
         * Globus hypermarket number in format XXXX.
         */
        localityId: number,
        /**
         * Limit
         */
        limit: number,
        /**
         * Offset
         */
        offset: number,
        apiVersion?: number,
        /**
         * Product type ID, if omitted, parameter is set to 1
         */
        productTypeId?: number,
        tags?: Array<string>,
        /**
         * Filter only orderable meals now
         */
        onlyOrderableNow?: boolean,
        /**
         * Filter only orderable meals today
         */
        onlyOrderableToday?: boolean,
        /**
         * Filter only by offer ids
         */
        offerIds?: Array<string>,
    }): CancelablePromise<OfferMealTypeResultCollectionResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/gastro/offers/all/mealType',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'frontendId': frontendId,
                'localityId': localityId,
                'productTypeId': productTypeId,
                'tags': tags,
                'limit': limit,
                'offset': offset,
                'onlyOrderableNow': onlyOrderableNow,
                'onlyOrderableToday': onlyOrderableToday,
                'offerIds': offerIds,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns the valid offers of meals for a frontend.
     * @returns MenuResultCollectionResult Offers were successfully found.
     * @throws ApiError
     */
    public static getMealMenu({
        frontendId,
        localityId,
        validFrom,
        validTo,
        apiVersion = 1,
        productTypeId,
    }: {
        /**
         * Frontend identifier
         */
        frontendId: number,
        /**
         * Globus hypermarket number in format XXXX.
         */
        localityId: number,
        /**
         * Optional filter from a specified date value in format YYYY-MM-DD.
         */
        validFrom: string,
        /**
         * Optional filter to a specified date value in format YYYY-MM-DD.
         */
        validTo: string,
        apiVersion?: number,
        /**
         * Product type ID, if omitted, parameter is set to 1
         */
        productTypeId?: number,
    }): CancelablePromise<MenuResultCollectionResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/gastro/offers/all/menu',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'frontendId': frontendId,
                'localityId': localityId,
                'productTypeId': productTypeId,
                'validFrom': validFrom,
                'validTo': validTo,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns a list of all active and available enumerators associated with offers.
     * @returns CommonAllEnumeratorsResultSingleResult Enumerators were successfully found.
     * @throws ApiError
     */
    public static commonGetAllEnumerators({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<CommonAllEnumeratorsResultSingleResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/gastro/offers/enumerators/all',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns a list of all enumerators filtered for available offers
     * @returns CommonAllEnumeratorsResultSingleResult Enumerators were successfully found.
     * @throws ApiError
     */
    public static commonGetAllEnumeratorsFiltered({
        frontendId,
        localityId,
        apiVersion = 1,
        productTypeId,
    }: {
        /**
         * Frontend identifier
         */
        frontendId: number,
        /**
         * Globus hypermarket number in format XXXX.
         */
        localityId: number,
        apiVersion?: number,
        /**
         * Product type ID, if omitted, parameter is set to 1
         */
        productTypeId?: number,
    }): CancelablePromise<CommonAllEnumeratorsResultSingleResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/gastro/offers/enumerators/filtered',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'frontendId': frontendId,
                'localityId': localityId,
                'productTypeId': productTypeId,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
